import Vue from 'vue';
import { Tabs, Tab } from 'vue-tabs-component';

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);




// WEBPACK FOOTER //
// ./src/plugins/vue-tabs.js